import * as types from 'src/state/ducks/orderItem/types';
import { Actions } from 'src/state/ducks/orderItem/actions';
import { OrderItemEntity } from 'src/firebase/db/OrderItems';
import { ValidationResponse } from 'src/firebase/db/ValidationManager';
import { APIFailedResponse } from 'src/firebase/db/DatabaseAdapter';

export interface Props {
  isFetching: boolean;
  isValidated: boolean;
  resource: OrderItemEntity[];
  validationErrors: ValidationResponse['errors'];
  apiError: APIFailedResponse['error'] | undefined;
}

const initialState: Props = {
  isFetching: false,
  isValidated: false,
  resource: [],
  validationErrors: {},
  apiError: undefined,
};

const orderItemReducer = (state = initialState, action: Actions): Props => {
  switch (action.type) {
    case types.GET_ORDER_ITEMS: {
      return {
        ...state,
        isFetching: true,
      };
    }

    case types.SUCCESS_GET_ORDER_ITEMS: {
      return {
        ...state,
        resource: action.payload.data,
        isFetching: false,
      };
    }

    case types.FAIL_GET_ORDER_ITEMS: {
      return {
        ...state,
        isFetching: false,
        validationErrors: 'errors' in action.payload ? action.payload.errors : {},
        apiError: 'error' in action.payload ? action.payload.error : undefined,
      };
    }

    case types.EDIT_ORDER_ITEM: {
      return {
        ...state,
        isValidated: false,
      };
    }

    case types.VALIDATE_ORDER_ITEM: {
      return {
        ...state,
        isValidated: false,
      };
    }

    case types.SUCCESS_VALIDATE_ORDER_ITEM: {
      return {
        ...state,
        isValidated: true,
      };
    }

    case types.FAIL_VALIDATE_ORDER_ITEM: {
      return {
        ...state,
        isValidated: false,
        validationErrors: 'errors' in action.payload ? action.payload.errors : {},
        apiError: 'error' in action.payload ? action.payload.error : undefined,
      };
    }

    case types.GET_DAY_ORDER_ITEMS: {
      return {
        ...state,
      };
    }

    case types.INIT_ORDER_ITEM: {
      return initialState;
    }

    default:
      return state;
  }
};

export default orderItemReducer;
